<template>
  <div class="slide">
    <div  class="super-jackpot-gr text-center">
      <div class="sj-header">
          <img src="https://cloud.aleacontrol.com/media/vDogs/super-jackpot-header-gr.svg"
            alt="super jackpot header image">
          <div class="title">
            <span>{{this.$t('vdog_super_jackpot_amount')}}</span>
          </div>
      </div>
      <div class="sj-body">
          <span>{{format(jackpotAmount)}} {{currency.toUpperCase()}}</span>
      </div>
      <div class="sj-footer text-center">
          <span>{{this.$t('vdog_ticket_location')}} {{ticketLocation}}</span>
          <span>{{this.$t('ticket_id')}}: {{partiallyMaskTicketId(ticketNo)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'
export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    ticketLocation: {
      type: String,
      required: true
    },
    jackpotAmount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    ticketNo: {
      type: String,
      required: true
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    },
    partiallyMaskTicketId: function (ticketId) {
      if (ticketId && ticketId.length > 4) {
        return '*'.repeat(ticketId.length - 4) + ticketId.slice(-4)
      }
    }
  }
}

</script>
